import { trigger, transition, animate, style, query, group, keyframes, state } from '@angular/animations';

export const inOutFade = trigger('inOutFade', [
   transition(':enter', [
      style({opacity: '0'}),
      animate('400ms', style({opacity: '1'}))
   ]),
   transition(':leave', [
      animate('400ms', style({opacity: '0'}))
   ])
]);

export const PopUp = trigger('PopUp', [
   transition(':enter', [
      style({transform: 'translate(0, 0) scale(0)'}),
      animate('250ms ease', style({transform: 'translate(0, 0) scale(1)'}))
   ]),
   transition(':leave', [
      style({transform: 'translate(0, 0) scale(1)'}),
      animate('250ms ease', style({transform: 'translate(0, 0) scale(0)'}))
   ])
]);

export const flipState =
   trigger('flipState', [
      state('active', style({
         transform: 'rotateY(179deg)'
      })),
      state('inactive', style({
         transform: 'rotateY(0)'
      })),
      transition('active => inactive', animate('500ms ease-out')),
      transition('inactive => active', animate('500ms ease-in'))
]);

export const PopUpRebote = trigger('PopUpRebote', [
   transition(':enter', [
      style({transform: 'translate(0, 0) scale(0)'}),
      animate('0.4s cubic-bezier(0.175, 0.285, 0.32, 1.1)', style({transform: 'translate(0, 0) scale(1)'}))
   ]),
   transition(':leave', [
      style({transform: 'translate(0, 0) scale(1)'}),
      animate('0.4s cubic-bezier(0.6, -0.28, 0.735, 0.045)', style({transform: 'translate(0, 0) scale(0)'}))
   ])
]);

export const inOutMenu = trigger('inOutMenu', [
   transition(':enter', [
   style({transform: 'translateX(-20px)', opacity: '0'}),
      animate('300ms ease', style({transform: 'translateX(0)', opacity: '1'}))
   ]),
   transition(':leave', [
      animate('300ms ease', style({transform: 'translateX(-20px)', opacity: '0'}))
   ])
])

export const inOutFromBottom = trigger('inOutFromBottom', [
   transition(':enter', [
      style({transform: 'translateY(100%)'}),
      animate('400ms ease', style({transform: 'translateY(0%)'}))
   ]),
   transition(':leave', [
      animate('400ms ease', style({transform: 'translateY(100%)'}))
   ])
]);

export const inOutFromTop = trigger('inOutFromTop', [
   transition(':enter', [
      style({transform: 'translateY(-100%)'}),
      animate('400ms ease', style({transform: 'translateY(0%)'}))
   ]),
   transition(':leave', [
      animate('400ms ease', style({transform: 'translateY(-100%)'}))
   ])
]);

export const inOutFromLeft = trigger('inOutFromLeft', [
   transition(':enter', [
      style({transform: 'translateX(-100%)'}),
      animate('400ms ease', style({transform: 'translateX(0%)'}))
   ]),
   transition(':leave', [
      animate('400ms ease', style({transform: 'translateX(-100%)'}))
   ])
]);

export const inOutFromRight = trigger('inOutFromRight', [
   transition(':enter', [
      style({transform: 'translateX(100%)'}),
      animate('400ms ease', style({transform: 'translateX(0%)'}))
   ]),
   transition(':leave', [
      animate('400ms ease', style({transform: 'translateX(100%)'}))
   ])
]);


export const changeSize = trigger('changeSize', [
   transition(':enter', [
      style({height: '0'}),
      animate('250ms ease', style({height: '100%'}))
   ]),
   transition(':leave', [
      style({height: '100%'}),
      animate('250ms ease', style({height: '0'}))
   ])
]);

export const slideRightIn=  trigger('slideRightIn', [
   transition(':enter', [
   style({transform: 'translateX(100%)'}),
      animate('350ms ease-out', style({transform: 'translateX(0%)'}))
   ]),
   transition(':leave', [
      animate('350ms ease-out', style({transform: 'translateX(100%)'}))
   ])
]);


export const co2 = trigger('co2', [
   transition(':enter', [
      style({transform: 'translateX(-100%)'}),
      animate('300ms ease', style({transform: 'translateX(0%)'}))
   ]),
   transition(':leave', [
      animate('300ms ease', style({transform: 'translateX(-100%)'}))
   ])
]);

export const arboles = trigger('arboles', [
   transition(':enter', [
      style({transform: 'translateX(+100%)'}),
      animate('300ms ease', style({transform: 'translateX(0%)'}))
   ]),
   transition(':leave', [
      animate('300ms ease', style({transform: 'translateX(+100%)'}))
   ])
])

export const inDesglose =  trigger('inDesglose', [
   transition(':enter', [
   style({opacity: '0', transform: 'scale(.9)'}),
      animate('500ms ease', style({opacity: '1', transform: 'scale(1)'}))
   ]),
   transition(':leave', [
      animate('300ms ease', style({opacity: '0'}))
   ])
]);

export const inEspecialDesglose =  trigger('inEspecialDesglose', [
   transition(':enter', [
      style({
         transform: 'scale(0)',
         left: '25%',
         top: '12%',
         borderRadius: '1000px'
      }),
      animate('1000ms ease',
         style({
            transform: 'scale(1)',
            left: '0%',
            top: '0%',
            borderRadius: '0px'
         }))
   ]),
   transition(':leave', [
      style({
         transform: 'scale(1)',
         left: '0%',
         top: '0%',
         borderRadius: '0px'
      }),
      animate('300ms ease', style({
         transform: 'scale(0)',
         left: '25%',
         top: '12%',
         borderRadius: '1000px'
      }))
   ])
]);



export const nav = trigger('nav', [
   state('in', style({transform: 'translateX(0)'})),
   transition('void => *', [
      style({transform: 'translateX(100%)'}),
      animate('350ms ease')
   ]),
   transition('* => void', [
      animate('350ms ease', style({transform: 'translateX(100%)'}))
   ])
]);

export const modal = trigger('modal', [
   state('in', style({transform: 'translateY(0)'})),
   transition('void => *', [
      style({transform: 'translateY(100%)'}),
      animate('350ms ease')
   ]),
   transition('* => void', [
      animate('350ms ease', style({transform: 'translateY(100%)'}))
   ])
])
